export const PARTNER_BASIC_INFO_TRANSLATIONS_NAMESPACE = 'jbp-partner-basic-info'

export const TRANSLATION_KEYS = {
  widgetTitle: PARTNER_BASIC_INFO_TRANSLATIONS_NAMESPACE,

  gradesLabel: `${PARTNER_BASIC_INFO_TRANSLATIONS_NAMESPACE}--grades--label`,
  emptyGradesLabel: `${PARTNER_BASIC_INFO_TRANSLATIONS_NAMESPACE}--grades--empty-grades-label`,
  specializationsLabel: `${PARTNER_BASIC_INFO_TRANSLATIONS_NAMESPACE}--specializations--label`,
  emptySpecializationsLabel: `${PARTNER_BASIC_INFO_TRANSLATIONS_NAMESPACE}--specializations--empty-specializations-label`,
  programsLabel: `${PARTNER_BASIC_INFO_TRANSLATIONS_NAMESPACE}--programs--label`,
  emptyProgramsLabel: `${PARTNER_BASIC_INFO_TRANSLATIONS_NAMESPACE}--programs--empty-programs-label`,

  retailerSummary: `${PARTNER_BASIC_INFO_TRANSLATIONS_NAMESPACE}--retailer-summary--label`,

  affectionOnCompleteness: 'partnerbasicinfo--tooltip--affection-on-completeness-message',
  valueRequiredForCompleteness: 'partnerbasicinfo--tooltip--value-required-for-completeness',

  locationsAndCount: {
    countLabel: `${PARTNER_BASIC_INFO_TRANSLATIONS_NAMESPACE}--locations-and-count--count-label`,
    locationsClickToEditLabel: `${PARTNER_BASIC_INFO_TRANSLATIONS_NAMESPACE}--locations-and-count--edit-locations-label`,
    locationsClickToViewLabel: `${PARTNER_BASIC_INFO_TRANSLATIONS_NAMESPACE}--locations-and-count--view-locations-label`,
  },
}
